import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserCircleFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "user circle",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.0217 14.6815C13.8587 14.6815 15.3517 13.1875 15.3517 11.3505C15.3517 9.51353 13.8587 8.01953 12.0217 8.01953C10.1847 8.01953 8.69165 9.51353 8.69165 11.3505C8.69165 13.1875 10.1847 14.6815 12.0217 14.6815Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 21.75C6.624 21.75 2.25 17.376 2.25 12C2.25 6.624 6.624 2.25 12 2.25C17.376 2.25 21.75 6.624 21.75 12C21.75 17.376 17.376 21.75 12 21.75ZM12 3.75C7.451 3.75 3.75 7.451 3.75 12C3.75 14.6657 5.02094 17.0403 6.98869 18.5495C7.56474 17.0638 9.18254 15.8398 12.0218 15.8398C14.8496 15.8398 16.4651 17.0496 17.047 18.5219C18.9944 17.0115 20.25 14.6496 20.25 12C20.25 7.451 16.549 3.75 12 3.75Z",
		fill: "currentColor"
	})]
});
export default SvgUserCircleFill;
